(function ($) {
  Drupal.behaviors.mantlehoverFormCheckbox = {
    attach: function (context, settings) {
      var $checkboxes = $('.js-mantle-form-hover-image-checkbox', context);

      $checkboxes.each(function (i, obj) {
        var $checkbox = $(obj);
        var $input = $('input[type="checkbox"]', $checkbox);

        $checkbox.on('click', function (event) {
          var checked = !$input.prop('checked');

          $input.trigger('checkbox-check', checked);
        });

        $input.on('checkbox-check', function (e, checked) {
          $input.prop('checked', checked);
          if (checked) {
            $checkbox.addClass('active');
          } else {
            $checkbox.removeClass('active');
          }
          $input.trigger('checkbox-checked', checked);
        });
      });
    }
  };
})(jQuery);
